declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
    __clicksdmpConsentMode?: boolean;
  }
}

/**
 * Google Consent Mode v2. Pushes the "denied" defaults and then grants analytics_storage.
 * Called only after the visitor accepted statistics cookies, right before gtm.js / gtag.js
 * are inserted, so the defaults are known before any tag fires. Idempotent.
 */
export const ensureConsentMode = () => {
  if (typeof window === 'undefined' || window.__clicksdmpConsentMode) return;
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function () {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer!.push(arguments);
    };
  }
  window.gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
    wait_for_update: 500,
  });
  window.gtag('consent', 'update', { analytics_storage: 'granted' });
  window.__clicksdmpConsentMode = true;
};

// GA4 Events — no-ops until the visitor accepted statistics cookies and gtag is loaded
export const trackEvent = (eventName: string, params?: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
  }
};

// Track form submissions (no form contents, only the form type)
export const trackFormSubmission = (formType: string) => {
  trackEvent('form_submission', {
    form_type: formType,
    page_location: window.location.href
  });
};

// Track portfolio views
export const trackPortfolioView = (projectId: string, projectTitle: string) => {
  trackEvent('view_item', {
    item_id: projectId,
    item_name: projectTitle,
    item_category: 'portfolio'
  });
};

// Track service interest
export const trackServiceInterest = (serviceName: string) => {
  trackEvent('select_content', {
    content_type: 'service',
    item_id: serviceName
  });
};

// Track every opening of the booking dialog (any "Termin buchen" button)
export const trackBookingClick = (source: string) => {
  trackEvent('booking_click', {
    source: source,
    page_location: window.location.href
  });
};

// Track WhatsApp clicks
export const trackWhatsAppClick = (source: string) => {
  trackEvent('whatsapp_click', {
    source: source,
    page_location: window.location.href
  });
};

// Track email clicks
export const trackEmailClick = () => {
  trackEvent('email_click', {
    page_location: window.location.href
  });
};

// Track phone clicks
export const trackPhoneClick = () => {
  trackEvent('phone_click', {
    page_location: window.location.href
  });
};

// Track blog post reads
export const trackBlogRead = (postSlug: string, postTitle: string) => {
  trackEvent('blog_read', {
    post_slug: postSlug,
    post_title: postTitle
  });
};

// Track scroll depth
export const trackScrollDepth = (depth: number) => {
  trackEvent('scroll_depth', {
    depth_percentage: depth
  });
};
